import React from 'react'
import Nav from '../../components/common/Nav'
import Footer from '../../components/common/Footer'
import AboutBody from '../../components/aboutpagecomponents/AboutBody'
export default function AboutPage() {
  return (
    <div>
     <Nav />
     <AboutBody />
     <Footer />
    </div>
  )
}
